/**
 * Created by Jan Bradac on 26.4.2016.
 */

(function (Lfl, $, undefined) {
    // TODO MOBA II - do we need this?
    Lfl.name = "Lfl";
}(window.Lfl = window.Lfl || {}, jQuery));
